/**
 * Judge.me Custom Override
 * Detects JudgeMe elements, extracts data, hides originals, and renders custom HTML
 * Style based on reviews-list.liquid
 *
 * Configuration (via data attributes on script tag or window.customJdgmConfig):
 * - filterByCurrentProduct: true/false - Only show reviews for the current product
 * - productHandle: string - Filter by a specific product handle
 */
(function() {
  var retryCount = 0;
  var maxRetries = 8;
  var initialized = false;
  var mutationObserver = null;

  // Get configuration
  var config = window.customJdgmConfig || {};

  // Try to get config from script tag data attributes
  var scriptTag = document.currentScript || document.querySelector('script[src*="judgeme-override"]');
  if (scriptTag) {
    if (scriptTag.dataset.filterByCurrentProduct !== undefined) {
      config.filterByCurrentProduct = scriptTag.dataset.filterByCurrentProduct === 'true';
    }
    if (scriptTag.dataset.productHandle) {
      config.productHandle = scriptTag.dataset.productHandle;
    }
  }

  // Get current product handle from URL or Shopify object
  function getCurrentProductHandle() {
    // Try from Shopify global object
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
      return window.ShopifyAnalytics.meta.product.handle;
    }
    // Try from URL (format: /products/product-handle)
    var match = window.location.pathname.match(/\/products\/([^\/\?#]+)/);
    if (match) {
      return match[1];
    }
    return null;
  }

  function initJudgeMeOverride() {
    if (initialized) return;

    // Find the JudgeMe carousel widget
    var judgemeWidget = document.querySelector('.jdgm-carousel-wrapper, .jdgm-widget.jdgm-carousel');

    if (!judgemeWidget) {
      scheduleRetry();
      return;
    }

    // Get review items
    var reviewItems = judgemeWidget.querySelectorAll('.jdgm-carousel-item');

    if (reviewItems.length === 0) {
      scheduleRetry();
      return;
    }

    initialized = true;

    // Extract data from JudgeMe widget
    var widgetData = extractWidgetData(judgemeWidget, reviewItems);

    // Filter reviews if configured
    if (config.filterByCurrentProduct || config.productHandle) {
      var targetHandle = config.productHandle || getCurrentProductHandle();
      if (targetHandle) {
        widgetData.reviews = widgetData.reviews.filter(function(review) {
          // Check if the product URL contains the target handle
          return review.productUrl && review.productUrl.indexOf('/products/' + targetHandle) !== -1;
        });
        // Update total count to reflect filtered reviews
        widgetData.totalReviews = widgetData.reviews.length;
      }
    }

    // Don't render if no reviews after filtering
    if (widgetData.reviews.length === 0) {
      return;
    }

    // Hide original JudgeMe widget
    judgemeWidget.style.display = 'none';

    // Create and insert custom HTML
    var customWidget = createCustomWidget(widgetData);
    judgemeWidget.parentNode.insertBefore(customWidget, judgemeWidget);

    // Initialize carousel functionality
    initCarousel(customWidget, widgetData.reviews.length);
  }

  /**
   * Extract all data from the JudgeMe widget
   */
  function extractWidgetData(widget, reviewItems) {
    var data = {
      title: '',
      averageRating: 0,
      totalReviews: 0,
      reviewsLink: '#',
      reviews: []
    };

    // Extract title
    var titleEl = widget.querySelector('.jdgm-carousel-title');
    if (titleEl) {
      data.title = titleEl.textContent.trim();
    }

    // Extract average rating (count stars)
    var starsContainer = widget.querySelector('.jdgm-all-reviews-rating');
    if (starsContainer) {
      var fullStars = starsContainer.querySelectorAll('.jdgm-star.jdgm--on').length;
      var halfStars = starsContainer.querySelectorAll('.jdgm-star.jdgm--half').length;
      data.averageRating = fullStars + (halfStars * 0.5);
    }

    // Extract total reviews count and link
    var reviewsLinkEl = widget.querySelector('.jdgm-carousel-number-of-reviews a');
    if (reviewsLinkEl) {
      data.reviewsLink = reviewsLinkEl.href || '#';
      var text = reviewsLinkEl.textContent.trim();
      var match = text.match(/(\d+)/);
      if (match) {
        data.totalReviews = parseInt(match[1], 10);
      }
    }

    // Extract each review
    reviewItems.forEach(function(item) {
      var review = {
        rating: 0,
        title: '',
        body: '',
        author: '',
        date: '',
        productTitle: '',
        productImage: '',
        productUrl: ''
      };

      // Rating (count stars)
      var ratingEl = item.querySelector('.jdgm-carousel-item__review-rating');
      if (ratingEl) {
        var stars = ratingEl.querySelectorAll('.jdgm-star.jdgm--on').length;
        var halfStars = ratingEl.querySelectorAll('.jdgm-star.jdgm--half').length;
        review.rating = stars + (halfStars * 0.5);
      }

      // Title
      var titleEl = item.querySelector('.jdgm-carousel-item__review-title');
      if (titleEl) {
        review.title = titleEl.textContent.trim();
      }

      // Body
      var bodyEl = item.querySelector('.jdgm-carousel-item__review-body');
      if (bodyEl) {
        review.body = bodyEl.textContent.trim();
      }

      // Author name
      var authorEl = item.querySelector('.jdgm-carousel-item__reviewer-name');
      if (authorEl) {
        review.author = authorEl.textContent.trim();
      }

      // Date
      var dateEl = item.querySelector('.jdgm-carousel-item__timestamp');
      if (dateEl) {
        review.date = dateEl.textContent.trim();
      }

      // Product info
      var productEl = item.querySelector('.jdgm-carousel-item__product');
      if (productEl) {
        review.productUrl = productEl.href || '#';

        var productImgEl = productEl.querySelector('.jdgm-carousel-item__product-image');
        if (productImgEl) {
          // Try data-src-retina first (higher quality), then data-src, then src
          review.productImage = productImgEl.getAttribute('data-src-retina')
            || productImgEl.getAttribute('data-src')
            || productImgEl.src
            || '';
        }

        var productTitleEl = productEl.querySelector('.jdgm-carousel-item__product-title');
        if (productTitleEl) {
          review.productTitle = productTitleEl.textContent.trim();
        }
      }

      data.reviews.push(review);
    });

    return data;
  }

  /**
   * Generate star HTML (same style as reviews-list)
   */
  function generateStars(rating) {
    var html = '';
    var fullStars = Math.floor(rating);
    var hasHalf = rating % 1 >= 0.5;

    for (var i = 0; i < 5; i++) {
      html += '<span class="custom-jdgm__star">';
      if (i < fullStars) {
        // Filled star
        html += '<svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
      } else if (i === fullStars && hasHalf) {
        // Half star
        html += '<svg width="15" height="15" viewBox="0 0 24 24"><defs><linearGradient id="half-grad-' + i + '"><stop offset="50%" stop-color="currentColor"/><stop offset="50%" stop-color="transparent"/></linearGradient></defs><path fill="url(#half-grad-' + i + ')" stroke="currentColor" stroke-width="1" d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
      } else {
        // Empty star
        html += '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
      }
      html += '</span>';
    }

    return html;
  }

  /**
   * Create the custom widget HTML (styled like reviews-list)
   */
  function createCustomWidget(data) {
    var widget = document.createElement('section');
    widget.className = 'custom-jdgm';
    widget.setAttribute('data-custom-jdgm', '');

    // Build reviews HTML
    var reviewsHtml = '';

    data.reviews.forEach(function(review, index) {
      reviewsHtml += `
        <div class="custom-jdgm__item" data-carousel-slide="${index}">
          <div class="custom-jdgm__card">
            ${review.productImage ? `
              <div class="custom-jdgm__avatar">
                <a href="${review.productUrl || '#'}">
                  <img src="${review.productImage}" alt="${escapeHtml(review.productTitle)}" class="custom-jdgm__avatar-img" loading="lazy">
                </a>
              </div>
            ` : ''}
            <div class="custom-jdgm__body">
              <div class="custom-jdgm__header">
                <span class="custom-jdgm__name">${escapeHtml(review.author)}</span>
                <div class="custom-jdgm__rating">
                  ${generateStars(review.rating)}
                </div>
              </div>
              <div class="custom-jdgm__content">
                ${review.title ? `<strong>${escapeHtml(review.title)}</strong><br>` : ''}
                ${escapeHtml(review.body)}
              </div>
              ${review.productTitle ? `
                <a href="${review.productUrl || '#'}" class="custom-jdgm__product-link">
                  ${escapeHtml(review.productTitle)}
                </a>
              ` : ''}
            </div>
          </div>
        </div>
      `;
    });

    // Build pagination dots
    var dotsHtml = '';
    if (data.reviews.length > 1) {
      data.reviews.forEach(function(_, index) {
        dotsHtml += `<button class="custom-jdgm__dot${index === 0 ? ' custom-jdgm__dot--active' : ''}" data-carousel-dot="${index}" aria-label="Aller à la diapositive ${index + 1}"></button>`;
      });
    }

    // Separator text
    var separatorText = data.title || 'Avis clients';
    if (data.totalReviews > 0) {
      separatorText += ' (' + data.totalReviews + ')';
    }

    widget.innerHTML = `
      <div class="custom-jdgm__separator">
        <span class="custom-jdgm__separator-text">${escapeHtml(separatorText)}</span>
        <div class="custom-jdgm__separator-rating">
          ${generateStars(data.averageRating)}
        </div>
        <span class="custom-jdgm__separator-line"></span>
      </div>

      <div class="custom-jdgm__container" data-reviews-carousel>
        ${reviewsHtml}
      </div>

      ${data.reviews.length > 1 ? `
        <div class="custom-jdgm__pagination" data-carousel-pagination>
          ${dotsHtml}
        </div>
      ` : ''}
    `;

    return widget;
  }

  /**
   * Escape HTML to prevent XSS
   */
  function escapeHtml(text) {
    if (!text) return '';
    var div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  /**
   * Initialize carousel functionality (same as reviews-list)
   */
  function initCarousel(widget, itemCount) {
    var carousel = widget.querySelector('[data-reviews-carousel]');
    var pagination = widget.querySelector('[data-carousel-pagination]');
    if (!carousel) return;

    var dots = pagination ? pagination.querySelectorAll('[data-carousel-dot]') : [];
    var slides = carousel.querySelectorAll('[data-carousel-slide]');

    if (slides.length === 0) return;

    // Update active dot based on scroll position
    function updateActiveDot() {
      var scrollLeft = carousel.scrollLeft;
      var containerWidth = carousel.offsetWidth;

      var activeIndex = 0;
      var minDistance = Infinity;

      slides.forEach(function(slide, index) {
        var slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
        var containerCenter = scrollLeft + containerWidth / 2;
        var distance = Math.abs(slideCenter - containerCenter);

        if (distance < minDistance) {
          minDistance = distance;
          activeIndex = index;
        }
      });

      dots.forEach(function(dot, index) {
        dot.classList.toggle('custom-jdgm__dot--active', index === activeIndex);
      });
    }

    // Click on dot to scroll to slide
    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        var index = parseInt(dot.dataset.carouselDot, 10);
        var targetSlide = slides[index];
        if (targetSlide) {
          var scrollPosition = targetSlide.offsetLeft - (carousel.offsetWidth - targetSlide.offsetWidth) / 2;
          carousel.scrollTo({ left: scrollPosition, behavior: 'smooth' });
        }
      });
    });

    // Listen for scroll events
    var scrollTimeout;
    carousel.addEventListener('scroll', function() {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(updateActiveDot, 50);
    });

    // Initial update
    updateActiveDot();
  }

  function scheduleRetry() {
    retryCount++;
    if (retryCount >= maxRetries) return;
    var delay = Math.min(100 * Math.pow(2, retryCount), 3000);
    setTimeout(initJudgeMeOverride, delay);
  }

  function watchForJudgeMe() {
    if (!window.MutationObserver) return;
    mutationObserver = new MutationObserver(function() {
      if (document.querySelector('.jdgm-carousel-wrapper, .jdgm-widget.jdgm-carousel')) {
        mutationObserver.disconnect();
        initJudgeMeOverride();
      }
    });
    mutationObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      watchForJudgeMe();
      setTimeout(initJudgeMeOverride, 300);
    });
  } else {
    watchForJudgeMe();
    setTimeout(initJudgeMeOverride, 300);
  }

  window.addEventListener('load', function() {
    if (!initialized) initJudgeMeOverride();
  });
})();

/**
 * Review card expand/collapse toggle
 */
(function() {
  function init() {
    document.addEventListener('click', function(e) {
      var rev = e.target.closest('.jdgm-rev');
      if (!rev) return;
      if (e.target.closest('a, button, input')) return;
      rev.classList.toggle('jdgm-rev--expanded');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
